import React, { useState } from "react";
import RevealOnScroll from "./RevealOnScroll";

const BandMemberCard = ({ member, reverseLayout, t }) => {
  const { name, imageUrl, imageAlt } = member;
  const memberKey = member.id === 1 ? "aran" : member.id === 2 ? "paulus" : member.id === 3 ? "daan" : "daniel";
  const localizedInstrument = t(`meetTheBand.${memberKey}.instrument`, member.instrument);
  const localizedBio = t(`meetTheBand.${memberKey}.bio`, member.bio);
  
  const [isExpanded, setIsExpanded] = useState(false);
  const layoutClasses = reverseLayout ? "md:flex-row-reverse" : "md:flex-row";
  const bioIsLong = localizedBio.length > 250;

  const getAgeFromDateTime = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if(m < 0 || (m === 0 && today.getDate() < birthDate.getDate())){
      age--;
    }
    return age;
  }

  return (
    <RevealOnScroll className="mb-16 md:mb-24">
      <div
        className={`flex flex-col group  ${layoutClasses} items-center md:items-start bg-gray-800 shadow-2xl rounded-lg overflow-hidden border border-gray-700 bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 `}
      >
        <div className="w-full md:w-2/5 lg:w-1/3 flex-shrink-0">
          <div className="relative overflow-hidden">
            <img
              src={imageUrl}
              alt={imageAlt}
              className="w-full h-auto object-cover transform transition-all duration-500 ease-in-out group-hover:scale-110 filter grayscale group-hover:grayscale-0"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-500"></div>
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          </div>
        </div>

        <div
          className={`w-full md:w-3/5 lg:w-2/3 p-6 md:p-8 lg:p-12 text-center md:text-left ${
            reverseLayout ? "md:pr-8 lg:pr-12" : "md:pl-8 lg:pl-12"
          }`}
        >
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-2">
            {name}
          </h3>
          <p className="text-xl text-gray-300 mb-4">{localizedInstrument}</p>

          <div
            className={`transition-[max-height] duration-700 ease-in-out overflow-hidden ${
              isExpanded ? "" : "max-h-48"
            }`}
          >
            {localizedBio.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                <p className="group-hover:text-gray-300 text-gray-500 ease-out duration-300 transition-all leading-relaxed text-lg">
                  {line.replace("{age}", getAgeFromDateTime(member.age))}
                </p>
                <br />
              </React.Fragment>
            ))}
          </div>

          {bioIsLong && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-teal-400 hover:text-teal-300 font-semibold mt-2 focus:outline-none transition-colors duration-300"
            >
              {isExpanded ? t("readLess") : t("readMore")}
            </button>
          )}
        </div>
      </div>
    </RevealOnScroll>
  );
};

export default BandMemberCard;
